function timeoutMaxValues() {
    setTimeout(function () {

     var inputEls = document.getElementsByName("quantity");
     var addCountEls = document.getElementsByClassName("btn-add");

     for (var i = 0; i < inputEls.length; i++){
       if(inputEls[i].value > inputEls[i].max){
         if(inputEls[i].value > inputEls[i].max){
       		 inputEls[i].value = inputEls[i].max;
         }
        addCountEls[i].disabled = true;
       }else{
        addCountEls[i].disabled = false;
       }
     }
     timeoutMaxValues();
    }, 1000);
}
  
timeoutMaxValues();


function serviceTileHover(x,size) {
  if(size == 'lg'){
  	x.style.backgroundColor = "#f1f6fc";
  }else{
    x.style.backgroundColor = "#fff";
  }
  x.style.cursor = "pointer";
}

function serviceTileOut(x,size) {
  if(size == 'lg'){
  	x.style.backgroundColor = "#fff";
  }else{
    x.style.backgroundColor = "inherit";
  }
}

$("#root").on('click', '.login-link', function(e) {
  e.preventDefault();
  e.stopPropagation();
  console.log($(this))
  $(this).off();
  //console.log('here');
  window.location.href = loginUrl
});


$(document).ready(function () {
  $('.gated div.view-product-wrapper').each(function(){ 
    $(this).find('.button.button-link').text('Login / Signup') 
  })
});


// Start appstle-loyalty-app code by HighFlexTech
function addSvgBeforeClass(className, svgMarkup) {
    const elements = document.querySelectorAll(`.${className}`);
    elements.forEach(element => {
      element.innerHTML = `${svgMarkup} ${element.innerHTML}`;
    });
}

const svgMarkup = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="
    height: 12px;
"><path fill="#ffffff" d="M190.5 68.8L225.3 128l-1.3 0-72 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l2.2 0c14.9 0 28.8 7.9 36.3 20.8zM64 88c0 14.4 3.5 28 9.6 40L32 128c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-41.6 0c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88l-2.2 0c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0L152 0C103.4 0 64 39.4 64 88zm336 0c0 22.1-17.9 40-40 40l-72 0-1.3 0 34.8-59.2C329.1 55.9 342.9 48 357.8 48l2.2 0c22.1 0 40 17.9 40 40zM32 288l0 176c0 26.5 21.5 48 48 48l144 0 0-224L32 288zM288 512l144 0c26.5 0 48-21.5 48-48l0-176-192 0 0 224z"></path></svg>`;

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(()=>{addSvgBeforeClass('loyalty-acquire-earn-points-label', svgMarkup);}, 1000);
});
// End appstle-loyalty-app code by HighFlexTech

// Custom loyalty styling and functions --------------------------------------------------------------------------------- START
// Function to hide elements with the class name "loyaltyBrandInfoBlock" inside the iframe
function hideLoyaltyBrandInfoBlocks() {
    const iframe = document.getElementById('appstle_loyalty_iframe');
    const innerDoc = iframe.contentDocument || iframe.contentWindow.document; // Access the iframe's document
    
    // Find all elements with the class name "loyaltyBrandInfoBlock"
    const elements = innerDoc.querySelectorAll('.loyaltyBrandInfoBlock');

    // Iterate over those elements and set their display style to none
    elements.forEach(element => {
        element.style.display = 'none';
    });
}

// Function to observe changes in the iframe's DOM and hide elements as necessary
function observeIframeChanges() {
    const iframe = document.getElementById('appstle_loyalty_iframe');
    const doc = iframe.contentDocument || iframe.contentWindow.document;

    const observer = new MutationObserver((mutations) => {
        for (let mutation of mutations) {
            if (mutation.type === 'childList') {
                // Call the hide function when changes are detected
                hideLoyaltyBrandInfoBlocks();
            }
        }
    });

    // Start observing the document
    observer.observe(doc.body, { childList: true, subtree: true });
}

// Make sure the iframe is ready before adding the observer
document.getElementById('appstle_loyalty_iframe').addEventListener('load', () => {
    observeIframeChanges(); // Start observing changes in the iframe
});

// Remove items from page by "removeElm" ID on any page / element

document.addEventListener("DOMContentLoaded", function() {
  setTimeout(function() {
    var el = document.getElementById("removeElm");
    if (el) {
      el.remove();
    }
  }, 10000); // 10,000ms = 10 seconds
});


// Custom loyalty styling and functions -------------------------------------------------------------------------------- FINISH

// Enforce strict item limits for restricted items on cart page -------------------------------------------------------- START
// Function to validate max value for all inputs with name "updates[]"
function validateQuantities() {
    const quantityInputs = document.querySelectorAll('input[name="updates[]"]');

    quantityInputs.forEach(input => {
        const maxValue = parseInt(input.max, 10); // Use base 10
        const currentValue = parseInt(input.value, 10); // Use base 10
        const addButton = input.nextElementSibling?.nextElementSibling; // '+' button
        
        // Check if current value exceeds max value
        if (currentValue > maxValue) {
            input.value = maxValue; // Set to maximum value
        }

        // Enable or disable the add button based on current quantity
        if (addButton) {
            addButton.disabled = currentValue >= maxValue; // Disable if limit is reached
        }
    });
}

// Attach event listeners to the quantity input fields
const quantityInputs = document.querySelectorAll('input[name="updates[]"]');

quantityInputs.forEach(input => {
    // Validate on change and blur
    input.addEventListener('change', validateQuantities);
    input.addEventListener('blur', validateQuantities);

    // Attach event listeners for the increment and decrement buttons
    const addButton = input.nextElementSibling?.nextElementSibling; // '+' button
    const removeButton = input.previousElementSibling; // '-' button

    // Add button listener
    if (addButton) {
        addButton.addEventListener('click', () => {
            //Not needed handled as part of splide code -- //input.value = parseInt(input.value, 10) + 1; // Increase quantity
            validateQuantities(); // Validate the updated quantity
        });
    }

    // Remove button listener
    if (removeButton) {
        removeButton.addEventListener('click', () => {
            input.value = parseInt(input.value, 10) - 1; // Decrease quantity
            if (input.value < 0) {
                input.value = 0; // Ensure it doesn't go below 0
            }
            validateQuantities(); // Validate after changing quantity
        });
    }
});

// Initial validation to set button state on page load
validateQuantities();
// Enforce strict item limits for restricted items on cart page ------------------------------------------------------- Finish
